export default __webpack_public_path__ + "static/media/shiffy-avatar.2977f8d8.svg";